export const MAX_TRACKER_SYNC_DAYS_AGO = 30;
